const EnvironmentPlugin = {
  install (Vue, options) {
    function getCurrentDomain () {
      let temp = window.location.hostname.split('.')
      if (temp.length > 1) {
        return temp[+temp.length - 2]
      } else {
        return temp[0]
      }
    }
    function getClientInfo () {
      let unknown = '-'
      // screen
      let screenSize = ''
      if (screen.width) {
        let width = (screen.width) ? screen.width : ''
        let height = (screen.height) ? screen.height : ''
        screenSize += '' + width + ' x ' + height
      }
      // browser
      let nVer = navigator.appVersion
      let nAgt = navigator.userAgent
      let browser = navigator.appName
      let version = '' + parseFloat(navigator.appVersion)
      let majorVersion = parseInt(navigator.appVersion, 10)
      let nameOffset, verOffset, ix
      // Opera
      if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browser = 'Opera'
        version = nAgt.substring(verOffset + 6)
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          version = nAgt.substring(verOffset + 8)
        }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
        browser = 'Opera'
        version = nAgt.substring(verOffset + 4)
      } else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
        // Edge
        browser = 'Microsoft Edge'
        version = nAgt.substring(verOffset + 5)
      } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // MSIE
        browser = 'Microsoft Internet Explorer'
        version = nAgt.substring(verOffset + 5)
      } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // Chrome
        browser = 'Chrome'
        version = nAgt.substring(verOffset + 7)
      } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // Safari
        browser = 'Safari'
        version = nAgt.substring(verOffset + 7)
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          version = nAgt.substring(verOffset + 8)
        }
      } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // Firefox
        browser = 'Firefox'
        version = nAgt.substring(verOffset + 8)
      } else if (nAgt.indexOf('Trident/') !== -1) {
        // MSIE 11+
        browser = 'Microsoft Internet Explorer'
        version = nAgt.substring(nAgt.indexOf('rv:') + 3)
      } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // Other browsers
        browser = nAgt.substring(nameOffset, verOffset)
        version = nAgt.substring(verOffset + 1)
        if (browser.toLowerCase() === browser.toUpperCase()) {
          browser = navigator.appName
        }
      }
      // trim the version string
      if ((ix = version.indexOf('')) !== -1) version = version.substring(0, ix)
      if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix)
      if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix)

      majorVersion = parseInt('' + version, 10)
      if (isNaN(majorVersion)) {
        version = '' + parseFloat(navigator.appVersion)
        majorVersion = parseInt(navigator.appVersion, 10)
      }

      // mobile version
      let mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer)

      // cookie
      let cookieEnabled = (navigator.cookieEnabled) === true

      if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1) === true
      }

      // system
      let os = unknown
      let clientStrings = [
        {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
        {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
        {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
        {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
        {s: 'Windows Vista', r: /Windows NT 6.0/},
        {s: 'Windows Server 2003', r: /Windows NT 5.2/},
        {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
        {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
        {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
        {s: 'Windows 98', r: /(Windows 98|Win98)/},
        {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
        {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s: 'Windows CE', r: /Windows CE/},
        {s: 'Windows 3.11', r: /Win16/},
        {s: 'Android', r: /Android/},
        {s: 'Open BSD', r: /OpenBSD/},
        {s: 'Sun OS', r: /SunOS/},
        {s: 'Linux', r: /(Linux|X11)/},
        {s: 'iOS', r: /(iPhone|iPad|iPod)/},
        {s: 'Mac OS X', r: /Mac OS X/},
        {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s: 'QNX', r: /QNX/},
        {s: 'UNIX', r: /UNIX/},
        {s: 'BeOS', r: /BeOS/},
        {s: 'OS/2', r: /OS\/2/},
        {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
      ]
      for (let id in clientStrings) {
        let cs = clientStrings[id]
        if (cs.r.test(nAgt)) {
          os = cs.s
          break
        }
      }

      let osVersion = unknown
      let regRes = null

      if (/Windows/.test(os)) {
        regRes = /Windows (.*)/.exec(os)
        osVersion = regRes ? regRes[1] : null
        os = 'Windows'
      }

      switch (os) {
        case 'Mac OS X':
          regRes = /Mac OS X (\w+)/.exec(nAgt)
          osVersion = regRes ? regRes[1] : null
          break
        case 'Android':
          regRes = /Android ([._\d]+)/.exec(nAgt)
          osVersion = regRes ? regRes[1] : null
          break
        case 'iOS':
          regRes = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer)
          if (regRes) {
            osVersion = regRes[1]
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (+osVersion[3] | 0)
          }
          break
      }
      let info = {
        screen: screenSize,
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile: mobile,
        os: os,
        osVersion: osVersion,
        cookies: cookieEnabled
      }
      return info
    }

    let environment = {
      currentDomain: getCurrentDomain(),
      isProduction: null,
      isChektDomain: null,
      authClientID: null,
      authDomain: null,
      authApiPath: null,
      authConnection: null,
      authScope: null,
      authCookieDomain: null,
      authTargetPath: null,
      apiTargetPath: null,
      apiPrefix: null,
      apiPath: null,
      operationWebUrl: null,
      dealerWebUrl: null,
      monitoringWebUrl: null,
      shareWebUrl: null,
      appWebUrl: null,
      psapUrl: null,
      deviceInfo: null
    }
    if (environment.currentDomain === 'chekt') {
      environment.isChektDomain = true
      environment.isProduction = true
    } else if (environment.currentDomain === 'chektdev') {
      environment.isChektDomain = true
      environment.isProduction = false
    } else if (environment.currentDomain === 'chektqe') {
      environment.isChektDomain = true
      environment.isProduction = false
      environment.isQe = true
    } else if (environment.currentDomain === 'github') {
      environment.isChektDomain = false
      environment.isProduction = false
    } else if (environment.currentDomain === 'firebaseapp') {
      environment.isChektDomain = false
      environment.isProduction = false
    } else if (environment.currentDomain === 'localhost') {
      environment.isChektDomain = false
      environment.isProduction = true
      environment.isProduction = false
    } else {
      environment.isChektDomain = false
      environment.isProduction = true
    }
    if (environment.isProduction) {
      environment.authClientID = 'bHzjpwmWpjwdOukz2h7FM2u2ND5BPKFa'
      environment.authDomain = 'chektcloud.auth0.com'
      environment.authConnection = 'Username-Password-Authentication'
      environment.authScope = 'openid offline_access'
      environment.authCookieDomain = '.chekt.com'
      environment.authTargetPath = 'account.chekt.com'
      environment.apiTargetPath = 'api.chekt.com'
      environment.apiPrefix = '/api/v1.1'
      environment.mqttTargetPath = 'commandcenter.chekt.com'
      environment.mqttTargetPathPort = 443
      environment.operationWebUrl = 'https://operation.chekt.com'
      environment.dealerWebUrl = 'https://dealer.chekt.com'
      environment.monitoringWebUrl = 'https://monitoring.chekt.com'
      environment.shareWebUrl = 'https://share.chekt.com'
      environment.appWebUrl = 'https://app.chekt.com'
      environment.psapUrl = 'https://share.chekt.com/psap'
    } else if (environment.isQe) {
      environment.authClientID = 'M2aHNcb8wnHqOGIvd7GpuZ8brfytFhWP'
      environment.authDomain = 'auth.chektqe.com'
      environment.authConnection = 'Username-Password-Authentication'
      environment.authScope = 'openid offline_access'
      environment.authCookieDomain = '.chektqe.com'
      environment.authTargetPath = 'account.chektqe.com'
      environment.apiTargetPath = 'api.chektqe.com'
      environment.apiPrefix = '/api/v1.1'
      environment.mqttTargetPath = 'commandcenter.chektqe.com'
      environment.mqttTargetPathPort = 443
      environment.operationWebUrl = 'https://operation.chektqe.com'
      environment.dealerWebUrl = 'https://dealer.chektqe.com'
      environment.monitoringWebUrl = 'https://monitoring.chektqe.com'
      environment.shareWebUrl = 'https://share.chektqe.com'
      environment.appWebUrl = 'https://app.chektqe.com'
      environment.psapUrl = 'https://share.chektqe.com/psap'
    } else {
      environment.authClientID = 'yeJIohNks41mYAiaID29JoxsZESOpEQ8'
      environment.authDomain = 'chektdev.auth0.com'
      environment.authConnection = 'Username-Password-Authentication'
      environment.authScope = 'openid offline_access'
      environment.authCookieDomain = '.chektdev.com'
      environment.authTargetPath = 'account.chektdev.com'
      environment.apiTargetPath = 'api.chektdev.com'
      environment.apiPrefix = '/api/v1.1'
      environment.mqttTargetPath = 'commandcenter.chektdev.com'
      environment.mqttTargetPathPort = 443
      environment.operationWebUrl = 'https://operation.chektdev.com'
      environment.dealerWebUrl = 'https://dealer.chektdev.com'
      environment.monitoringWebUrl = 'https://monitoring.chektdev.com'
      environment.shareWebUrl = 'https://share.chektdev.com'
      environment.appWebUrl = 'https://app.chektdev.com'
      environment.psapUrl = 'https://share.chektdev.com/psap'
    }
    environment.apiPath = 'https://' + environment.apiTargetPath + environment.apiPrefix
    environment.authApiPath = 'https://' + environment.authDomain
    let clientInfo = getClientInfo()
    environment.deviceInfo = clientInfo['os'] + ' ' + clientInfo['osVersion'] + '-' + clientInfo['browser'] + (clientInfo['mobile'] ? '-Mobile' : '') + '-' + window.location.hostname
    Vue.prototype.$env = environment
    Vue.env = environment
  }
}

export default EnvironmentPlugin



// WEBPACK FOOTER //
// ./src/plugins/environment.js